import { render } from "./FundInvestmentsSelector.vue?vue&type=template&id=6450b0d3"
import script from "./FundInvestmentsSelector.vue?vue&type=script&lang=js"
export * from "./FundInvestmentsSelector.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./FundInvestmentsSelector.vue?vue&type=style&index=1&id=6450b0d3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__